const videoInputFound = (devices: MediaDeviceInfo[]) => {
  return devices.some((device) => device.kind === 'videoinput');
};

export const checkIfCamerasSupported = async () => {
  const result = await navigator.mediaDevices.enumerateDevices();
  return videoInputFound(result);
};
